import { Project } from '../../../project/Project';

export const getProjectIrisCode = (project: Project): string | null =>
  project.parcels && project.parcels[0] && project.parcels[0].properties.id
    ? project.parcels[0].properties.id.substring(0, 9)
    : null;
